import { ModaSofa } from '@dora/backpack';
import { DrawerCtaContentInfo, DrawerWithCta } from '@dora/components';
import { SxProps } from '@mui/system';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Preact from 'preact';
import * as H from 'preact/hooks';
import * as DrawerInner from './configureModaSofa/drawerInner';
import { sizing } from '@dora/components';

export type Props = {
    /** If the configuration should affect an existing sofa, a sofaId will be included */
    handleChange: (configuration: ModaSofa.Configuration, sofaId: O.Option<string>) => void;
    currentConfiguration: O.Option<{ sofaId: string; configuration: ModaSofa.Configuration }>;
    platform: sizing.Platform;
    portrait: boolean;
    open: boolean;
    onClose: () => void;
    title: string;
    range: string;
    loading: boolean;
    sx?: SxProps;
    paddingTop?: number;
};

export function Component(props: Props) {
    const [shape, setShape] = H.useState('');
    const [count, setCount] = H.useState(0);
    const [config, setConfig] = H.useState<null | ModaSofa.Configuration>(null);
    return (
        <DrawerWithCta.Component
            platform={props.platform}
            portrait={props.portrait}
            open={props.open}
            onClose={props.onClose}
            title={props.title}
            sx={props.sx}
            paddingTop={props.paddingTop}
            // This ensures that the form matches the current state of the scene. Without this, it
            // persists state between invocations.
            mountOptions={{ mountOnEnter: true, unmountOnExit: true }}
            confirmationBarContents={
                <DrawerCtaContentInfo.Component
                    information1={`${props.range} ${shape} sofa`}
                    information2={`Seats ${count} people`}
                    loading={props.loading}
                    buttonText="Update"
                    onClick={() => {
                        if (config !== null) {
                            return props.handleChange(
                                config,
                                pipe(
                                    props.currentConfiguration,
                                    O.map(c => c.sofaId),
                                ),
                            );
                        }
                    }}
                />
            }
        >
            <DrawerInner.Component
                currentConfiguration={props.currentConfiguration}
                loading={props.loading}
                onShapeChange={setShape}
                onSeatCountChange={setCount}
                onConfigurationChange={setConfig}
            ></DrawerInner.Component>
        </DrawerWithCta.Component>
    );
}
